import { Controller } from "@hotwired/stimulus"
import { prefersReducedMotion, replayAnimation } from "../lib/motion"

const SPOTLIGHT_FALLBACK_MS = 700

// /help topic tiles: the tile nudges its arrow, the page glides to the FAQ group it names, and the group lights up on
// arrival (title pill + ring) so the tap visibly lands somewhere. Focus moves to the group title. Reduced motion: jump.
export default class extends Controller {
  jump(event) {
    const group = document.getElementById(event.currentTarget.getAttribute("href")?.slice(1) || "")
    if (!group) return
    event.preventDefault()

    replayAnimation(event.currentTarget, "is-pressed")
    const reduced = prefersReducedMotion()
    group.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" })

    let done = false
    const arrive = () => {
      if (done) return
      done = true
      clearTimeout(this.timer)
      window.removeEventListener("scrollend", arrive)
      group.querySelector(".help-group-title")?.focus({ preventScroll: true })
      replayAnimation(group, "is-spotlit")
    }
    if (reduced) return arrive()
    // scrollend never fires when the page is already there (or unsupported): arrive on a timer then
    window.addEventListener("scrollend", arrive, { once: true })
    this.timer = setTimeout(arrive, SPOTLIGHT_FALLBACK_MS)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
